module.exports = __webpack_public_path__ + "img/hotel-star-inn-lisbon.18a233ce.jpg";